import { DATTORMM_URL } from "../constants";
import { apiSlice } from "./apiSlice";

export const dattoRmmApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getDattoSiteDevices: builder.query({
            query: (siteUid) => ({
                url: `${DATTORMM_URL}/site/${siteUid}/devices`,
            }),
            keepUnusedDataFor: 5
        }),
        getDattoOpenAlerts: builder.query({
            query: () => ({
                url: `${DATTORMM_URL}/alerts/open`,
            }),
            keepUnusedDataFor: 5
        }),
    })
});

export const { useGetDattoSiteDevicesQuery, useGetDattoOpenAlertsQuery } = dattoRmmApiSlice;
export default dattoRmmApiSlice;

